/**
 * Created by mac on 2017/5/25.
 */
const getters = {
  isRcMcpath: state => state.user.isRcMcpath,
  mcpath: state => state.user.mcpath,
  userInfo: state => state.user.userInfo,
  authorization:state => state.user.authorization,
  homeLogo:state => state.user.homeLogo,
  addRouters: state => state.permission.addRouters,
  roles: state => state.user.roles,
  routes: state => state.permission.routers,
  isInitRouter: state => state.user.isInitRouter,
  r_param: state => state.tmp.r_param,
  ter_param: state => state.ter.ter_param,
  edit_change: state => state.ter.edit_change,
  nick: state => state.user.nick,
  comUri: state => state.permission.comUri,
  gIfurl: state => state.tmp.gurl
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js